import React from "react";
import { InputLabel } from "@material-ui/core";

export const StyledLabel = props => (
  <InputLabel
    htmlFor={props.htmlFor}
    style={
      {
        fontWeight: "bold",
        fontSize: "17px",
        color: "black"
      }
    }
  >
    {props.isEditing ? <div style={{ display: "block", height: "4px" }} /> : ""}
    <div style={{ marginTop: "7px" }}>{props.text}</div>
  </InputLabel>
);
